import { render, staticRenderFns } from "./policyHolder.vue?vue&type=template&id=0dd4d214&scoped=true&"
import script from "./policyHolder.vue?vue&type=script&lang=js&"
export * from "./policyHolder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd4d214",
  null
  
)

export default component.exports